import React from 'react';
import { format } from 'date-fns';

const StudentExperience = ({ data }: { data: any }) => {
  const workExperience = data?.workExperience || [];
  return (
    <div className='pt-4  px-6 lg:pr-16 border-t-2'>
      <div className='flex space-x-2 items-center'>
        <div className='border-r-2 pr-4 font-semibold text-xl'>Experience</div>
      </div>

      {workExperience.map((workExp: any, index: number) => {
        return (
          <div key={index}>
            <div className='md:flex justify-between items-center'>
              {/* company info */}
              <div className='flex md:basis-3/5 lg:basis-1/2 space-x-3 items-center mt-8 mb-6'>
                {/* <img
            src='/images/studentInfo/school3.png'
            alt='school'
            className='h-20 w-20 object-contain'
          /> */}
                <div>
                  <p className=' font-semibold text-lg mb-2'>
                    {workExp.title}{' '}
                  </p>
                  <p className='text-sm mb-1'>{workExp.companyName} </p>
                  <p className='text-sm text-primary'>{workExp.jobType} </p>
                </div>
              </div>
              <div className='flex md:basis-2/5 lg:basis-1/2 justify-between mb-4 md:mb-0'>
                <div className='space-y-1'>
                  <p className='font-semibold text-base'>
                    {workExp.startDate &&
                      format(new Date(workExp.startDate), 'MMM u')}{' '}
                    -{' '}
                    {workExp.endDate &&
                      format(new Date(workExp.endDate), 'MMM u')}
                  </p>
                  <div className='flex space-x-1'>
                    {/* <img
                      src='/images/studentInfo/map-marker.png'
                      alt='marker'
                      className='h-5 w-5 object-contain'
                    /> */}
                    <p>{workExp.country} </p>
                  </div>
                </div>
              </div>
            </div>

            <p className='my-6'>{workExp.description}</p>
          </div>
        );
      })}
    </div>
  );
};

export default StudentExperience;
